var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import FadeIn from '../../../../components/Animation/FadeIn';
import Button from '../../../../components/Button';
import { useWizard } from '../../../../hooks/useWizard';
import Heading from '../../../../components/Typography/Heading';
import { useOutletContext } from 'react-router-dom';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Paragraph from '../../../../components/Typography/Paragraph';
import FormRow from '../../../../components/Form/Row';
import TextInput from '../../../../components/Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import { Party } from '../../../../components/CustomIcon';
import ModalFull from '../../../../components/Modal/ModalFull';
import FadeUp from '../../../../components/Animation/FadeUp';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
var ProfessionalSocial = function () {
    var values = useOutletContext().values;
    var _a = useWizard(), setValuesAndGoToNextStep = _a.setValuesAndGoToNextStep, skipAndGoToNextStep = _a.skipAndGoToNextStep;
    var urlOptional = useValidation().urlOptional;
    var placeholders = usePlaceholder();
    var _b = useState(false), stepCompleted = _b[0], setStepCompleted = _b[1];
    var _c = useState(3000), modalDuration = _c[0], setModalDuration = _c[1];
    var schema = yup.object().shape({
        social_instagram: urlOptional,
        social_facebook: urlOptional,
        social_linkedin: urlOptional,
        social_twitter: urlOptional,
        social_malt: urlOptional,
        social_youtube: urlOptional,
        social_tiktok: urlOptional,
        social_other: urlOptional,
    });
    var _d = useForm({
        resolver: yupResolver(schema),
        defaultValues: values,
    }), handleSubmit = _d.handleSubmit, control = _d.control;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setStepCompleted(true);
            setTimeout(function () {
                setValuesAndGoToNextStep(data);
            }, 3000);
            return [2 /*return*/];
        });
    }); };
    var skipStep = function () {
        setStepCompleted(true);
        setTimeout(function () {
            skipAndGoToNextStep();
        }, modalDuration);
    };
    return (<FadeIn>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            Vous êtes sur les réseaux sociaux&nbsp;?
          </Heading>
          <Paragraph size="sm" className="pt-2 text-gray-700">
            Ajoutez les réseaux que vous utilisez de façon professionnelle.
          </Paragraph>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow>
              <TextInput label="Instagram" type={Fields.TEXT} name="social_instagram" placeholder={placeholders.social_instagram} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Facebook" type={Fields.TEXT} name="social_facebook" placeholder={placeholders.social_facebook} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Linkedin" type={Fields.TEXT} name="social_linkedin" placeholder={placeholders.social_linkedin} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Twitter" type={Fields.TEXT} name="social_twitter" placeholder={placeholders.social_twitter} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Malt" type={Fields.TEXT} name="social_malt" placeholder={placeholders.social_malt} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Youtube" type={Fields.TEXT} name="social_youtube" placeholder={placeholders.social_youtube} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Tiktok" type={Fields.TEXT} name="social_tiktok" placeholder={placeholders.social_tiktok} control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Autre" type={Fields.TEXT} name="social_other" placeholder={placeholders.social_other} control={control}/>
            </FormRow>
            <div className="flex items-center justify-between">
              <Button onClick={skipStep} type="inline">
                Passer
              </Button>
              <Button submit>Continuer</Button>
            </div>
          </div>
        </form>
      </div>

      <ModalFull open={stepCompleted} bgType={2} mainColClassName="max-md:mb-20" duration={modalDuration}>
        <FadeUp>
          <Party className="fill-white" size={86}/>
        </FadeUp>
        <FadeUp>
          <Heading level={1} type="h2" className="mt-6">
            Parfait !
          </Heading>
        </FadeUp>
        <FadeUp>
          <Paragraph size="lg" className="mt-2">
            Discutons à présent de vos expériences...
          </Paragraph>
        </FadeUp>
      </ModalFull>
    </FadeIn>);
};
export default ProfessionalSocial;
